import { Trans } from '@lingui/react'

import {
  Headline,
  HeadlineIcon,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { BigUserIcon } from '@twisto/icons'

import { useFlow } from '../../flow/flow.context'

export const AccountExistsWithoutPasswordStep = () => {
  const { flow } = useFlow<'AccountExistsWithoutPasswordStep'>()

  const { email } = flow.currentStep

  return (
    <Headline>
      <HeadlineIcon>
        <BigUserIcon color="primary" height="100%" width="100%" />
      </HeadlineIcon>
      <HeadlineTitle>
        <Trans
          id="flow.accountExistsWithoutPasswordStep.modal.title"
          values={{ email: email.value }}
        />
      </HeadlineTitle>
    </Headline>
  )
}
